module.exports = __webpack_public_path__ + "static/media/rightLine2.ece4f53a.svg";